import { combineReducers } from 'redux';
import analyticsReducer from './analyticsReducer';
import authReducer from './authReducer';
import billingReducer from './billingReducer';
import channelReducer from './channelReducer';
import chatReducer from './chatReducer';
import connectedPartyReducer from './connectedPartyReducer';
import emailReducer from './emailReducer';
import facebookReducer from './facebookReducer';
import groupReducer from './groupReducer';
import inboxReducer from './inboxReducer';
import messageTemplateReducer from './messageTemplateReducer';
import nativeAppReducer from './nativeAppReducer';
import officeReducer from './officeReducer';
import organizationReducer from './organizationReducer';
import outOfOfficeReducer from './outOfOfficeReducer';
import payReducer from './payReducer';
import rhinovideoReducer from './rhinovideoReducer';
import phoneReducer from './phoneReducer';
import rhinogramReducer from './rhinogramReducer';
import prefixReducer from './prefixReducer';
import roleReducer from './roleReducer';
import savedContentReducer from './savedContentReducer';
import secureReducer from './secureReducer';
import stateReducer from './stateReducer';
import suffixReducer from './suffixReducer';
import systemAlertReducer from './systemAlertReducer';
import tagReducer from './tagReducer';
import timeZoneReducer from './timeZoneReducer';
import auditLogReducer from './auditLogReducer';
import typeReducer from './typeReducer';
import uiReducer from './uiReducer';
import userReducer from './userReducer';
import appointmentReducer from './appointmentReducer';
import languageReducer from './languageReducer';
import formReducer from './formReducer';
import appointmentTypesReducer from './appointmentTypesReducer';
import appointmentCampaignReducer from './appointmentCampaignReducer';

const appReducer = combineReducers({
  analytics: analyticsReducer,
  appointment: appointmentReducer,
  appointmentCampaign: appointmentCampaignReducer,
  appointmentTypes: appointmentTypesReducer,
  auditLog: auditLogReducer,
  auth: authReducer,
  billing: billingReducer,
  channel: channelReducer,
  chat: chatReducer,
  connectedParty: connectedPartyReducer,
  email: emailReducer,
  facebook: facebookReducer,
  form: formReducer,
  group: groupReducer,
  inbox: inboxReducer,
  language: languageReducer,
  messageTemplate: messageTemplateReducer,
  nativeApp: nativeAppReducer,
  office: officeReducer,
  organization: organizationReducer,
  outOfOffice: outOfOfficeReducer,
  pay: payReducer,
  phone: phoneReducer,
  prefix: prefixReducer,
  rhinogram: rhinogramReducer,
  rhinovideo: rhinovideoReducer,
  role: roleReducer,
  savedContent: savedContentReducer,
  secure: secureReducer,
  states: stateReducer,
  suffix: suffixReducer,
  systemAlert: systemAlertReducer,
  tag: tagReducer,
  timeZone: timeZoneReducer,
  type: typeReducer,
  ui: uiReducer,
  user: userReducer,
});

const rootReducer = (state, action) => {
  let updatedState = state;

  if (action.type === 'AUTH/clearAuth') {
    updatedState = undefined;
  } else if (action.type === 'AUTH/unsetUser') {
    updatedState = {
      ui: state.ui,
    };
  }

  return appReducer(updatedState, action);
};

export default rootReducer;
